// Protokół gry – lustro backend/common/protocol.py. Zmiany zawsze w obu miejscach (i w shared/protocol/protocol.json).
export const PROTOCOL_VERSION = 1;

export const C = { HELLO: 'hi', MOVE: 'mv', STOP: 'st', ATTACK: 'at', USE: 'us', PICKUP: 'pu', CHAT: 'ch', PING: 'pi' } as const;
export const S = { WELCOME: 'wl', ACK: 'ak', DELTA: 'dt', EVENT: 'ev', CHAT: 'cm', ERROR: 'er', PONG: 'po' } as const;

export const PLAYER_SPEED_MPS = 4.0;
export const STEP_S = 0.1;
export const PLAYER_RADIUS_M = 0.3;
export const AOI_RADIUS_M = 48.0;

export const E_PLAYER = 1;
export const E_ZOMBIE = 2;
export const E_NPC = 3;
export const E_ITEM = 4;

/** [id, typ, x, y, hp%, nazwa/kod] */
export type EntityState = [number, number, number, number, number, string];

export interface Welcome { t: 'wl'; you: number; x: number; y: number; layer: number; tick_hz: number; hp: number; hp_max: number; speed: number; step_s: number }
export interface Ack { t: 'ak'; s: number; x: number; y: number }
export interface Delta { t: 'dt'; tick: number; ent: EntityState[]; gone: number[] }
export interface GameEvent { t: 'ev'; kind: string; [k: string]: unknown }
export interface ChatMsg { t: 'cm'; ch: string; from: string; msg: string }
export interface ErrorMsg { t: 'er'; code: string; msg: string }
export type ServerMessage = Welcome | Ack | Delta | GameEvent | ChatMsg | ErrorMsg | { t: 'po'; ts: number; srv: number };
